import {usePreferredDark, useStorage} from '@vueuse/core'
import {computed, watch} from 'vue'

export type ColorMode = 'light' | 'dark' | 'auto'

export function useColorMode() {
  const prefersDark = usePreferredDark()
  const mode = useStorage<ColorMode>('color-mode', 'auto')

  const isDark = computed(() => (mode.value === 'auto' ? prefersDark.value : mode.value === 'dark'))

  watch(
    isDark,
    (dark) => {
      document.documentElement.classList.toggle('dark', dark)
    },
    {immediate: true}
  )

  return {mode, isDark}
}
